import classNames from 'classnames';
import './style.scss'

import { ReactComponent as LoaderCircle } from 'assets/img/loader-circle.svg'

export const Loader = () => <div className={classNames('loader')}><LoaderCircle /></div>